<template>
  <form ref="formRef" novalidate @submit.prevent="saveInstitucional" class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-3 w-100">
        <h2 class="fw-bold fs-5 m-0 mt-1">{{ $t('infoInstitucional') }}</h2>
        <button @click="isEditingInstitucional = true" v-if="(hasEditarPersonaPermission && !isEditingInstitucional) || isEditingPerfil" type="button" class="btn p-0 d-flex flex-row align-items-center justify-content-center tooltip-container border-0">
          <svg width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21 21H12" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <span class="tooltip-text">{{ $t('editar') }}</span>
        </button>
      </div>

      <div class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('cargo') }}:</label>
        <p v-if="!isEditingInstitucional || isEditingPerfil" class="m-0">{{ localPersona.Cargo }}</p>
        <input v-if="isEditingInstitucional && !isEditingPerfil" type="text" v-model="localPersona.Cargo" class="form-control fondo-principal sombra-sm" :disabled="!isEditingInstitucional" maxlength="50"/>
      </div>
      <div v-if="!isEditingPerfil && esProfesor" class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('tipoDocente') }}:</label>
        <p v-if="!isEditingInstitucional" class="m-0">{{ displayTipoDocente }}</p>
        <div v-if="isEditingInstitucional" class="select-wrapper w-100 position-relative">
          <select v-model="localPersona.TipoDocente" class="form-select fondo-principal sombra-sm" :disabled="!isEditingInstitucional">
            <option :value="null">{{ $t('ninguno') }}</option>
            <option v-for="tipo in tiposDocente" :key="tipo.codigo" :value="tipo.codigo">
              {{ tipo.codigo }}
            </option>
          </select>
          <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
        </div>
      </div>
      <div v-if="!isEditingPerfil && esProfesor" class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('siglaUntis') }}:</label>
        <p v-if="!isEditingInstitucional || isEditingPerfil" class="m-0">{{ localPersona.SiglaUntis }}</p>
        <input v-if="isEditingInstitucional && !isEditingPerfil" type="text" v-model="localPersona.SiglaUntis" class="form-control fondo-principal sombra-sm" :disabled="!isEditingInstitucional" maxlength="3"/>
      </div>
      <div v-if="tieneLegajo" class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('legajo') }}:</label>
        <p v-if="!isEditingInstitucional || isEditingPerfil" class="m-0">{{ localPersona.LegajoIdEmpleado }}</p>
        <input v-if="isEditingInstitucional && !isEditingPerfil" type="text" v-model="localPersona.LegajoIdEmpleado" class="form-control fondo-principal sombra-sm" :disabled="!isEditingInstitucional" />
      </div>
      <div v-if="!isEditingPerfil" class="mb-3 d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('fechaIngreso') }}:</label>
        <p v-if="!isEditingInstitucional" class="m-0">{{ formattedFechaIng || 'N/A' }}</p>
        <input v-if="isEditingInstitucional" type="date" v-model="formattedFechaIng" class="form-control fondo-principal sombra-sm" :disabled="!isEditingInstitucional"/>
        <div class="invalid-feedback">{{ $t('fechaIngresoRequerida') }}</div>
      </div>
      <div class="d-flex flex-column">
        <label class="m-0 texto-secundario fs-7">{{ $t('nivelSector') }}:</label>
        <p v-if="!isEditingInstitucional" class="m-0">{{ selectedNivelSectores }}</p>
        <div v-if="isEditingInstitucional">
          <div v-for="(nivelSector, index) in localPersona.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858')" :key="'nivelSector' + index" class="d-flex flex-row gap-2 mb-2">
            <div class="select-wrapper w-100 position-relative">
              <select v-model="nivelSector.IdLista" @change="updateNivelSectorLista(nivelSector)" class="form-select fondo-principal sombra-sm" :disabled="!isEditingInstitucional" required>
                <option v-for="n in nivelesSectores.Listas" :key="n.IdLista" :value="n.IdLista">{{ n.Nombre }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
              <div class="invalid-feedback position-absolute" style="position: absolute !important;">{{ $t('nivelSectorRequerido') }}</div>
            </div>
            <button v-if="!isEditingPerfil || index !== 0" type="button" class="btn danger-btn p-2 d-flex flex-row align-items-center justify-content-center" @click="removeNivelSector(index)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <button type="button" class="btn btn-primary mt-2" @click="addNivelSector">
            {{ $t('agregarNivelSector') }}
          </button>
        </div>
      </div>

      <div v-if="isEditingInstitucional" class="d-flex justify-content-end gap-2 mt-3">
        <button class="btn success-btn sombra-sm d-flex align-items-center gap-2" type="submit" :disabled="loadingInstitucional">
          {{ $t('guardarCambios') }}
          <img v-if="loadingInstitucional" src="@/assets/LOADING.gif" style="width: 20px;" alt="Cargando..." />
        </button>
        <button class="btn secondary-btn sombra-sm" type="button" @click="cancelEdit">{{ $t('cancelar') }}</button>
      </div>
    </div>
  </form>
</template>

<script>
import { ref, computed, watch, onMounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import api from '@/services/api';

export default {
  name: 'InfoInstitucionalSection',
  props: {
    persona: {
      type: Object,
      required: true
    },
    hasEditarPersonaPermission: {
      type: Boolean,
      default: false
    },
    isEditingPerfil: {
      type: Boolean,
      default: false
    },
    tieneLegajo: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isEditingInstitucional = ref(false);
    const loadingInstitucional = ref(false);
    const nivelesSectores = ref({});
    const localPersona = ref({
      ...props.persona,
      PersonasListas: [...(props.persona.PersonasListas || [])]
    });
    const errors = ref({});
    const formRef = ref(null);

    const esProfesor = computed(() => {
      const roles = localPersona.value.PersonasRoles;
      if (!roles || !Array.isArray(roles)) return false;
      return roles.some(pr => pr.Rol && pr.Rol.Rol === 'Profesor');
    });

    const tiposDocente = ref([
      { "codigo": "ADLK-Enviado/a Alemán" },
      { "codigo": "AUL-ES-Ayudante de Laboratorios" },
      { "codigo": "AUM-ES-Ayudante de Medios" },
      { "codigo": "BIB-Bibliotecario/a" },
      { "codigo": "BPLK-Contratado/a Alemán" },
      { "codigo": "CAT-Coord. de Alemán Transversal" },
      { "codigo": "CCC-ES-Coordinador/a de Convivencia" },
      { "codigo": "CEF-Coordinador/a Educación Física" },
      { "codigo": "CMT-Coord. de Matemática Transversal" },
      { "codigo": "CND-Cargo no docente" },
      { "codigo": "DCL-Docente con licencia" },
      { "codigo": "DED-Extraprogramáticos deportivos" },
      { "codigo": "DEF-Docente Educación Física" },
      { "codigo": "DEX-Extraprogramáticos" },
      { "codigo": "DFT-ES-Docente Full Time" },
      { "codigo": "DGG-Director/a General" },
      { "codigo": "DIR-Director/a" },
      { "codigo": "DOLK-Deutsche Ortslehrkraft" },
      { "codigo": "DPT-ES-Docente Part-Time" },
      { "codigo": "DSU-Docente suplente" },
      { "codigo": "EOE-Equipo de Orientación Escolar" },
      { "codigo": "EXD-Ex-Docente" },
      { "codigo": "JIC-Jefe/a de integración curricular" },
      { "codigo": "MAA-Maestro/a de Alemán" },
      { "codigo": "MAB-Maestro/a de Bilingüe" },
      { "codigo": "MAC-Maestro/a de Castellano" },
      { "codigo": "MAI-Maestro/a de Inglés" },
      { "codigo": "MAM-Maestro/a de Música" },
      { "codigo": "MAN-Maestro/a de Ciencias Naturales" },
      { "codigo": "MAS-Maestro/a Secretario/a" },
      { "codigo": "MEA-Maestro/a de Artística" },
      { "codigo": "MI-Maestro/a de Educación Inicial" },
      { "codigo": "MMA-Maestro/a de Matemática" },
      { "codigo": "MSU-Maestro/a Suplente" },
      { "codigo": "OLK-Ortslehrkraft" },
      { "codigo": "PR-Preceptor/a" },
      { "codigo": "PRS-Prosecretario/a Pedagógico/a" },
      { "codigo": "SCR-Secretario/a" },
      { "codigo": "SEP-Secretario/a Pedagógico/a" },
      { "codigo": "VDA-Vicedirector/a Alemán" },
      { "codigo": "VDG-Vicedirector/a General" },
      { "codigo": "VDI-Vicedirector/a" }
    ]);

    const displayTipoDocente = computed(() => {
      if (!localPersona.value.TipoDocente) return 'N/A';
      const found = tiposDocente.value.find(t => t.codigo === localPersona.value.TipoDocente);
      return found ? found.codigo : localPersona.value.TipoDocente;
    });

    console.log("localPersona.value");
    console.log(localPersona.value);
    const fetchNivelSector = async () => {
      try {
        const response = await api.get(`api/Grupos/555F125B-184F-4B46-97B4-7D4B54A56858`);
        nivelesSectores.value = response.data;
      } catch (error) {
        console.error('Error al obtener niveles sectores:', error);
      }
    };

    const selectedNivelSectores = computed(() => {
      if (!localPersona.value.PersonasListas) return 'N/A';
      return localPersona.value.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858').map(pog => pog.Lista.Nombre).join(', ') || 'N/A';
    });

    const addNivelSector = () => {
      if (!localPersona.value.PersonasListas) localPersona.value.PersonasListas = [];
      localPersona.value.PersonasListas.push({ IdLista: null, IdPersona: props.persona.IdPersona, Lista: { IdGrupoDeListas: '555f125b-184f-4b46-97b4-7d4b54a56858' } });
    };

    const removeNivelSector = (index) => {
      const filtered = localPersona.value.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858');
      const toRemove = filtered[index];
      localPersona.value.PersonasListas = localPersona.value.PersonasListas.filter(pog => pog !== toRemove);
    };

    const updateNivelSectorLista = (nivelSector) => {
      const option = nivelesSectores.value.Listas.find(o => o.IdLista == nivelSector.IdLista);
      nivelSector.Lista = option;
    };

    const cancelEdit = () => {
      localPersona.value = {
        ...props.persona,
        PersonasListas: [...(props.persona.PersonasListas || [])]
      };
      isEditingInstitucional.value = false;
      formRef.value?.classList.remove('was-validated');
    };

    const formattedFechaIng = computed({
      get() {
        // Si no hay fecha, devolvemos vacío
        if (!localPersona.value.FechaIngreso) return '';
        
        // Extraemos solo los primeros 10 caracteres (YYYY-MM-DD)
        return localPersona.value.FechaIngreso.split('T')[0];
      },
      set(nuevoValor) {
        // Cuando el usuario elige una fecha, actualizamos el objeto original
        localPersona.value.FechaIngreso = nuevoValor;
      }
    });

    const validateInstitucional = async () => {
      errors.value = {};
      let isValid = true;
      if (props.isEditingPerfil) {
        const filtered = localPersona.value.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858');
        if (filtered.length === 0 || filtered.some(ns => !ns.IdLista)) {
          errors.value.nivelSector = t('nivelSectorRequerido');
          isValid = false;
        }
      }
      await nextTick();
      if (!isValid) {
        formRef.value?.classList.add('was-validated');
      } else {
        formRef.value?.classList.remove('was-validated');
      }
      return isValid;
    };

    const saveInstitucional = async () => {
      if (!(await validateInstitucional())) {
        return;
      }
      loadingInstitucional.value = true;
      try {
        const NivelSector = localPersona.value.PersonasListas ? localPersona.value.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858').map(pog => pog.IdLista) : [];
        const data = {
          cargo: localPersona.value.Cargo,
          legajoId: localPersona.value.LegajoIdEmpleado === "" ? null : localPersona.value.LegajoIdEmpleado,
          selectedNivelSectorIds: NivelSector,
          fechaIngreso: localPersona.value.FechaIngreso,
          siglaUntis: localPersona.value.SiglaUntis,
          IdPersona: localPersona.value.IdPersona,
          TipoDocente: localPersona.value.TipoDocente
        };
        await api.put(`api/Persona/${props.persona.IdPersona}/info-institucional`, data);
        isEditingInstitucional.value = false;
        emit('updated');
      } catch (error) {
        console.error('Error al guardar info institucional:', error);
        alert('Hubo un problema al guardar la información institucional.');
      } finally {
        loadingInstitucional.value = false;
      }
    };

    watch(() => props.persona, (newPersona) => {
      localPersona.value = {
        ...newPersona,
        PersonasListas: [...(newPersona.PersonasListas || [])]
      };
    }, { immediate: true });

    watch(isEditingInstitucional, (newVal) => {
      if (newVal && props.isEditingPerfil) {
        const filtered = localPersona.value.PersonasListas.filter(pog => pog.Lista && pog.Lista.IdGrupoDeListas == '555f125b-184f-4b46-97b4-7d4b54a56858');
        if (filtered.length === 0) {
          addNivelSector();
        }
      }
    });

    onMounted(() => {
      fetchNivelSector();
    });

    return {
      t,
      isEditingInstitucional,
      loadingInstitucional,
      localPersona,
      selectedNivelSectores,
      addNivelSector,
      removeNivelSector,
      updateNivelSectorLista,
      saveInstitucional,
      nivelesSectores,
      validateInstitucional,
      errors,
      formRef,
      cancelEdit,
      formattedFechaIng,
      tiposDocente,
      displayTipoDocente,
      esProfesor,
    };
  },
};
</script>

<style>
</style>